module.exports = __webpack_public_path__ + "static/img/wenke.7e13f992.png";